import { cn } from "@babackapp/ui/lib/utils";

interface StepIndicatorProps {
  status: "completed" | "active" | "pending";
  stepNumber: number;
}

export function StepIndicator({ status }: StepIndicatorProps) {
  return (
    <div className="bg-muted w-full h-2 rounded-full overflow-hidden">
      <div
        className={cn(
          "w-full h-full rounded-full",
          {
            completed: "bg-primary",
            active: "bg-primary w-1/2",
            pending: "bg-muted",
          }[status],
        )}
      />
    </div>
  );
}
